import React from 'react';

import { type CellContext } from '@tanstack/react-table';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';

interface CellIndexProps<TData, TValue> extends CellContext<TData, TValue> {
    value: string;
}

export function CellValidationReason<TData, TValue>({ value }: CellIndexProps<TData, TValue>) {
    return (
        <Tooltip>
            <TooltipProvider>
                <TooltipTrigger className="truncate">{value}</TooltipTrigger>
                <TooltipContent className="max-w-xs text-wrap">{value}</TooltipContent>
            </TooltipProvider>
        </Tooltip>
    );
}
